module.exports = __webpack_public_path__ + "media/images/comingsoon_600_450-21a571abc169cd06d9af5ab11a71a2dc.jpg";